import type { Bounds, RoundingFunction } from './types';

const roundOrReturn = (value: number, round?: RoundingFunction): number => {
  return round?.(value) ?? value;
};

/**
 * Retrieves the bounding rectangle of an element, optionally rounding the values.
 *
 * @param element - The element to get the bounds for.
 * @param round - Optional function to round the values.
 * @returns An object containing the bounds of the element.
 */
export const getBounds = <T extends Element>(element: T, round?: RoundingFunction): Bounds => {
  const bounds = element.getBoundingClientRect();
  let { bottom, height, left, right, top, width } = bounds;

  bottom = roundOrReturn(bottom, round);
  height = roundOrReturn(height, round);
  left = roundOrReturn(left, round);
  right = roundOrReturn(right, round);
  top = roundOrReturn(top, round);
  width = roundOrReturn(width, round);

  return { bottom, height, left, right, top, width };
};
